import type { PaymentSources as PaymentSourcesType } from "../types/index";

export const PaymentSources: PaymentSourcesType = {
  CUSTOM_CHECKOUT: "custom_checkout",
  CHECKOUT: "checkout",
  PAY_REQUEST: "pay_request",
  PAYMENT_PLAN: "payment_plan",
};
